import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import * as Yup from 'yup';

import { ReactComponent as CleanIcon } from '../../../../assets/icons/ubr_clean.svg';
import { ReactComponent as Download } from '../../../../assets/icons/ubr_download.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/ubr_filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Shimmer,
  Select,
  Modal,
  Pagination,
  // Pagination,
} from '../../../../components';
import Accordion from '../../../../components/Accordion';
import api from '../../../../services/api';
import { EndpointsAPI } from '../../../../services/Endpoints';
import checkValidIntervalDate from '../../../../utils/checkValidIntervalDate';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { hash } from '../../../../utils/hashGenerator';
import { periodo } from './periodo';
import {
  Badge,
  Container,
  TableContainer,
  FooterTable,
  InputGroup,
  ActionsForm,
  OrderContainer,
  LoadingData,
  List,
} from './styles';

interface SearchProps {
  identificadorEmpresa?: any | undefined;
  periodo?: string | undefined;
  dataFim?: any;
  dataInicio?: any;
}

export enum StatusType {
  Default = 'DEFAULT',
  Pendente = 'PENDENTE',
  Processando = 'PROCESSANDO',
  Sucesso = 'SUCESSO',
  Erro = 'ERRO',
}

interface DataProps {
  agencia: string;
  conta: string;
  cooperativa: string;
  identificadorEmpresa: string;
  dataOperacao: string;
  processoConvenioDTO: {
    idProcesso: string;
    mensagemProcesso: string;
    status: StatusType;
    leitorCnab: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    motorCnab: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    leitorPdf: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    motorPdf: [
      {
        idArquivoMotor: string;
        status: StatusType;
        dataCriacao: string;
        motorEnum: string;
      },
    ];
    motorCnabPdf: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    motorHomologacao: string;
  };
  tipoCnab: string;
}

const RelatorioAnalitico: React.FC = () => {
  const [data, setData] = useState<DataProps | any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const formRef = useRef<FormHandles | null>(null);
  const [order, setOrder] = useState<boolean>();
  let selectedPeriodo = useRef<any>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filter, setFilter] = useState<any>({
    identificadorEmpresa: null,
    dataInicio: null,
    dataFim: null,
    periodo: null,
    paginacao: {
      direcao: !order ? 'ASC' : 'DESC',
      numeroPagina: currentPage,
      tamanhoPagina: itemsPerPage,
    },
    produto: 'CONVENIOS',
  });
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [showErrorPDFModal, setShowErrorPDFModal] = useState<boolean>(false);
  const [showErrorCNABxPDFModal, setShowErrorCNABxPDFModal] = useState<boolean>(
    false,
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [idError, setIdError] = useState<string>();
  const [dataError, setDataError] = useState<[]>([]);

  const showModalError = (id: string) => {
    setShowErrorModal(true);
    setIdError(id);
    fetchError(id);
  };

  const fetchError = useCallback(async (id: string) => {
    const { data } = await api.get(
      EndpointsAPI.motorConvenios + `/${id}/criticas`,
    );

    setDataError(data);
  }, []);

  const fetchData = useCallback(
    async (search: any) => {
      formRef.current?.setErrors({});
      setIsLoading(true);

      try {
        const response = await api.post(
          EndpointsAPI.relatorioAnaliticoConvenios,
          search,
        );
        setData(response.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    },
    [filter, itemsPerPage, currentPage, order],
  );

  const handleDownloadFiles = async (idProcesso: string) => {
    const response = await api.get(
      EndpointsAPI.baixarPorIdProcessoConvenio + `/${idProcesso}/download`,
      {
        responseType: 'arraybuffer',
      },
    );

    const url = URL.createObjectURL(
      new Blob([response?.data], {
        type: 'blob',
      }),
    );
    FileSaver.saveAs(url, `${idProcesso}.rar`);
  };

  useEffect(() => {
    fetchData({
      ...filter,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: currentPage,
        tamanhoPagina: itemsPerPage,
      },
    });
  }, [currentPage, itemsPerPage, order]);

  function formatDate(data: string) {
    if (!data) {
      return 'N/D';
    }
    let dateLocal = new Date(data);
    return (
      dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString()
    );
  }

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '100px' }}>
                <OrderContainer>
                  Parceiro
                  {order ? (
                    <button onClick={() => setOrder(false)}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => setOrder(true)}>
                      <AiOutlineArrowDown />
                    </button>
                  )}
                </OrderContainer>
              </th>

              <th style={{ width: '160px' }}>Data da Operação</th>
              <th style={{ width: '260px' }}>Validação</th>
              <th style={{ width: '100px' }}>Tipo CNAB</th>
              <th style={{ width: '100px' }}>Ações</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data!?.content!?.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data!?.content!?.map((todo: DataProps, index: number) => {
                return (
                  <tr key={index}>
                    <td data-column="Parceiro">{todo.identificadorEmpresa}</td>

                    <td data-column="Data da Operação">
                      {formatDate(todo.dataOperacao)}
                    </td>
                    <td data-column="Validação">
                      <div>
                        <Badge
                          type={
                            todo.processoConvenioDTO.motorCnab
                              ? todo.processoConvenioDTO.motorCnab.status
                              : StatusType.Default ||
                                todo.processoConvenioDTO.leitorCnab
                              ? todo.processoConvenioDTO.leitorCnab.status
                              : StatusType.Default
                          }
                          onClick={
                            todo.processoConvenioDTO.leitorCnab === null
                              ? () => {}
                              : todo.processoConvenioDTO.leitorCnab.status ===
                                StatusType.Erro
                              ? () =>
                                  showModalError(
                                    todo.processoConvenioDTO.leitorCnab
                                      .idArquivoMotor,
                                  )
                              : todo.processoConvenioDTO.motorCnab === null
                              ? () => {}
                              : todo.processoConvenioDTO.motorCnab.status ===
                                StatusType.Erro
                              ? () =>
                                  showModalError(
                                    todo.processoConvenioDTO.motorCnab
                                      .idArquivoMotor,
                                  )
                              : () => {}
                          }
                        >
                          CNAB
                        </Badge>
                      </div>
                    </td>
                    <td data-column="Tipo CNAB">{`Tipo CNAB`}</td>
                    <td data-column="Ações">
                      <div>
                        <Button
                          variant="solid-icon"
                          onClick={() =>
                            setTimeout(() => {
                              handleDownloadFiles(
                                todo.processoConvenioDTO.idProcesso,
                              );
                            }, 500)
                          }
                          tooltipText={'Download dos Arquivos'}
                        >
                          <Download style={{ width: '20px' }} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  const today = moment(new Date()).format('YYYY-MM-DD');

  const handleFilter = async (data: SearchProps) => {
    data.periodo = selectedPeriodo.current;

    if ((data.dataInicio || data.dataFim) && !data.identificadorEmpresa) {
      data.identificadorEmpresa = null as any;
    }
    try {
      formRef.current?.setErrors({});
      if (data.dataInicio > today) {
        const schema = Yup.object().shape({
          dataInicio: Yup.number().typeError(
            'Data de início não pode ser maior que hoje',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
      }
      if (data.dataFim > today) {
        const schema = Yup.object().shape({
          dataFim: Yup.number().typeError(
            'Data de fim não pode ser maior que hoje',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
      }

      if (!data.periodo) {
        if (!checkValidIntervalDate(data.dataInicio, data.dataFim)) {
          const schema = Yup.object().shape({
            dataInicio: Yup.number().typeError(
              'Data de Inicio deve ser menor que Data Final',
            ),
          });
          const select = formRef!.current!.getFieldRef('periodo');
          select.select.clearValue();
          await schema.validate(data, {
            abortEarly: false,
          });
        }
      }
      if (data.dataInicio || data.dataFim) {
        const schema = Yup.object().shape({
          dataInicio: Yup.string().required('Este campo é obrigatório!'),
          dataFim: Yup.string().required('Este campo é obrigatório!'),
        });
        const select = formRef!.current!.getFieldRef('periodo');
        select.select.clearValue();
        await schema.validate(data, {
          abortEarly: false,
        });
      }

      setFilter({
        identificadorEmpresa: data.identificadorEmpresa
          ? data.identificadorEmpresa
          : null,
        dataInicio: data.dataInicio ? data.dataInicio : null,
        dataFim: data.dataFim ? data.dataFim : null,
        periodo: data.periodo ? data.periodo : null,
        paginacao: {
          direcao: !order ? 'ASC' : 'DESC',
          numeroPagina: currentPage,
          tamanhoPagina: itemsPerPage,
        },
        produto: 'CONVENIOS',
      });

      if ((data.dataInicio || data.dataFim) && data.periodo) {
        const select = formRef!.current!.getFieldRef('periodo');
        select.select.clearValue();
      } else {
        fetchData({
          identificadorEmpresa: data.identificadorEmpresa
            ? data.identificadorEmpresa
            : null,
          dataInicio: data.dataInicio ? data.dataInicio : null,
          dataFim: data.dataFim ? data.dataFim : null,
          periodo: data.periodo ? data.periodo : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'CONVENIOS',
        });
        setIsLoading(false);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      }
    }
  };

  // Sort Data

  const onClear = () => {
    formRef.current?.reset();
    formRef.current?.setErrors({});

    const select = formRef!.current!.getFieldRef('periodo');
    select.select.clearValue();

    fetchData({
      identificadorEmpresa: null,
      dataInicio: null,
      dataFim: null,
      periodo: null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'CONVENIOS',
    });
  };

  return (
    <>
      <Modal
        show={
          showErrorModal
            ? showErrorModal
            : showErrorPDFModal
            ? showErrorPDFModal
            : showErrorCNABxPDFModal
            ? showErrorCNABxPDFModal
            : false
        }
        titulo={
          showErrorModal
            ? 'Erro no arquivo CNAB enviado'
            : showErrorPDFModal
            ? 'Erro no(s) PDF(s) enviados'
            : showErrorCNABxPDFModal
            ? 'Erro ao comparar CNAB e PDF'
            : ''
        }
        mensagem={`Você deve verificar os erros, corrigi-los e tentar novamente.`}
        onCancel={() => {
          showErrorModal && setShowErrorModal(false);
          showErrorPDFModal && setShowErrorPDFModal(false);
          showErrorCNABxPDFModal && setShowErrorCNABxPDFModal(false);
          setDataError([]);
        }}
        onConfirm={() => {}}
      >
        {(dataError.length && showErrorModal) ||
        (dataError.length && showErrorPDFModal) ? (
          dataError.map((data: any, index: number) => {
            return (
              <>
                <List>
                  <div className="list-content-secondary">
                    <span>
                      <b> ERRO ENCONTRADO: </b>
                    </span>
                    {data.mensagem}
                  </div>

                  {showErrorPDFModal && (
                    <li>
                      <b className="list-content-principal">
                        DETALHES DE ERRO:{' '}
                      </b>
                      <>Linha: {data.linha}</>
                    </li>
                  )}

                  <li>
                    {showErrorModal && (
                      <b className="list-content-principal">
                        DETALHES DO ERRO:{' '}
                      </b>
                    )}
                    {showErrorPDFModal && (
                      <b className="list-content-principal">POSIÇÕES: </b>
                    )}

                    <>
                      {showErrorModal && <>Linha: {data.posicaoLinha}</>}{' '}
                      Posição Inicial: {data.posicaoInicial}, Posição Final:{' '}
                      {data.posicaoFinal}
                    </>
                  </li>
                  {data.valorEsperado === null ||
                  data.valorEsperado === undefined ||
                  data.valorEsperado === '' ||
                  data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                    <li>
                      <b className="list-content-principal">VALOR ESPERADO: </b>
                      {data.valorEsperado}
                    </li>
                  )}
                  <li>
                    <b className="list-content-principal">VALOR INFORMADO: </b>
                    {data.valor}
                  </li>
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title="Mais Informações"
                    description={
                      <>
                        <li>
                          <b>Campo: </b>
                          {data.chave}
                        </li>
                        <li>
                          <b>Tipo de segmento: </b>
                          {data.tipoValidacaoModelo}
                        </li>

                        <li>
                          <b>Tipo de validação: </b>
                          {data.validacaoCritica}
                        </li>
                      </>
                    }
                  />
                </List>
              </>
            );
          })
        ) : dataError.length && showErrorCNABxPDFModal ? (
          dataError.map((data: any, index: number) => {
            return (
              <>
                <List>
                  <div className="list-content-secondary">
                    <span>
                      <b> ERRO ENCONTRADO: </b>
                    </span>
                    {data.mensagem}
                  </div>

                  <li>
                    <b className="list-content-principal">DETALHES DE ERRO: </b>
                    <>
                      Linha: <b>{data.linha}</b>
                    </>
                  </li>
                  {data.valorEsperado === null ||
                  data.valorEsperado === undefined ||
                  data.valorEsperado === '' ||
                  data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                    <li>
                      <b className="list-content-principal">
                        VALOR ESPERADO DO CNAB:{' '}
                      </b>
                      {data.valorEsperado}
                    </li>
                  )}
                  <li>
                    <b className="list-content-principal">
                      VALOR INFORMADO DO PDF:{' '}
                    </b>
                    {data.valor}
                  </li>
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title="Mais Informações"
                    description={
                      <>
                        <li>
                          <b>Campo: </b>
                          {data.chave}
                        </li>
                        <li>
                          <b>Tipo de segmento: </b>
                          {data.tipoValidacaoModelo}
                        </li>

                        <li>
                          <b>Tipo de validação: </b>
                          {data.validacaoCritica}
                        </li>
                      </>
                    }
                  />
                </List>
              </>
            );
          })
        ) : (
          <>
            <div style={{ marginTop: '2rem' }}>
              <Shimmer height={'25px'} />
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ marginTop: '1rem' }}>
                <Shimmer height={'25px'} />
              </div>
            </div>
          </>
        )}
      </Modal>
      <Container>
        <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
          <FilterIcon width={28} />
          <InputGroup>
            <Input
              name="identificadorEmpresa"
              label="Identificador Parceiro"
              type="text"
              mask={'identificadorParceiro'}
              placeholder="Ex.: 13600000000000000000"
              style={{ width: 250 }}
              disableMargin={true}
            />
            <Input
              name="dataInicio"
              label="Data Inicio"
              type="date"
              max={today}
              placeholder="Date"
              disableMargin={true}
            />
            <Input
              name="dataFim"
              label="Data Fim"
              type="date"
              max={today}
              placeholder="Date"
              disableMargin={true}
            />

            <div className="select-field">
              <Select
                name={'periodo'}
                isMulti={false}
                options={periodo}
                initialValues={"30"}
                onChange={option => (selectedPeriodo.current = option.value)}
                placeholder="Selecione"
                label="Período"
              />
            </div>
          </InputGroup>
          <ActionsForm>
            <div>
              <Button
                variant="solid-icon"
                type={'submit'}
                style={{ marginRight: '1rem' }}
                tooltipText={'Pesquisar'}
              >
                <SearchIcon style={{ width: '26px' }} />
              </Button>
              <Button
                variant="solid-icon"
                type={'reset'}
                onClick={onClear}
                tooltipText={'Limpar Campos'}
              >
                <CleanIcon style={{ width: '26px' }} />
              </Button>
            </div>
            {/* <Button
              onClick={() => relatoryDownload()}
              variant={'solid-icon'}
              tooltipText={'Baixar Relatório'}
              style={{ width: '24px' }}
            >
              <DownloadIcon />
            </Button> */}
          </ActionsForm>
        </Form>
        {renderData()}
        <FooterTable>
          <Pagination
            pageCount={data.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={data.size}
            forcePage={currentPage}
            onPageChange={(pageNumber: any) => {
              setCurrentPage(pageNumber.selected);
            }}
            onPageSize={(pageSize: any) => {
              setCurrentPage(0);
              setitemsPerPage(pageSize.value);
            }}
          />
        </FooterTable>
      </Container>
    </>
  );
};

export default RelatorioAnalitico;
